import { FormattedMessage, useIntl } from 'react-intl';
import { FaSpinner } from 'react-icons/fa';
import { Button, Col, Radio, Row, Spin, Table, Typography } from 'antd';
import { TableProps } from 'antd/lib/table/Table';
export type { ColumnsType } from 'antd/lib/table/Table';

import DefaultEmpty from '../DefaultEmpty';
import { useWindowSize } from '@/hooks';
import Group from '../Group';
import { getTableScrollX } from '@/utils/table';

export interface InfiniteTableProps<T> extends TableProps<T> {
  isFetching?: boolean;
  hasNextPage?: boolean;
  fetchNextPage?: () => void;
  rowChange?: (row: number) => void;
  loading?: boolean;
}

// eslint-disable-next-line
function InfiniteTable<T extends object>({
  hasNextPage,
  fetchNextPage,
  rowChange,
  isFetching,
  ...rest
}: InfiniteTableProps<T>) {
  const intl = useIntl();
  const { isMobile } = useWindowSize();

  return (
    <>
      {!!rowChange && (
        <Row
          gutter={[24, 24]}
          style={{ marginBottom: 24 }}
          justify="end"
          align="middle"
        >
          <Col span={isMobile ? 24 : undefined}>
            <Typography.Text>
              <strong>Resultados:</strong>{' '}
              {!!rest.dataSource && rest.dataSource.length > 0 ? (
                rest.dataSource.length
              ) : rest.loading ? (
                <Spin />
              ) : (
                'nenhum resultado encontrado'
              )}
            </Typography.Text>
          </Col>

          <Col span={isMobile ? 24 : undefined}>
            <Typography.Text>
              <strong>Exibir: </strong>
            </Typography.Text>

            <Radio.Group
              optionType="button"
              defaultValue={10}
              buttonStyle="solid"
              onChange={(e) => rowChange(e.target.value)}
            >
              <Radio value={10}>10</Radio>
              <Radio value={25}>25</Radio>
              <Radio value={50}>50</Radio>
            </Radio.Group>
          </Col>
        </Row>
      )}
      <Table<T>
        {...rest}
        scroll={
          rest?.columns
            ? {
                x: rest?.columns.every(
                  (column) => typeof column?.width === 'number',
                )
                  ? getTableScrollX(rest.columns)
                  : true,
              }
            : undefined
        }
        size="small"
        className={'table-small'}
        pagination={false}
        locale={{
          emptyText: <DefaultEmpty className="default-table-empty" />,
        }}
        loading={{
          spinning: rest.loading,
          indicator: <FaSpinner className="loading-spinner" />,
          tip: intl.formatMessage({ id: 'commons.form.loading' }),
        }}
      />

      {!!hasNextPage && !!fetchNextPage && (
        <Group position="center" style={{ marginTop: 24 }}>
          <Button
            onClick={() => fetchNextPage()}
            loading={isFetching}
            block={isMobile}
          >
            <FormattedMessage id="commons.table.loadMore" />
          </Button>
        </Group>
      )}
    </>
  );
}

InfiniteTable.EXPAND_COLUMN = Table.EXPAND_COLUMN;

export default InfiniteTable;
